import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const TicketGuard = createFeatureGuard(Feature.Tickets);